import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import "./PartialPaymentSummary.scss";
import StateContext from "../../StateContext";
import { formatMoney } from "../../helper/customeObj";

function PartialPaymentSummary({ invoiceDetails, className = "" }) {
  const { t } = useTranslation();
  const appState = useContext(StateContext);

  if (!invoiceDetails?.is_partial) return null;

  const invoiceable = invoiceDetails?.invoiceable || {};
  const partials = Array.isArray(invoiceDetails?.partials)
    ? invoiceDetails.partials
    : [];
  const totalBill = Number(invoiceable?.amount ?? 0);
  const paidFromPartials = partials
    .filter((p) => p?.status === "Paid")
    .reduce((sum, p) => sum + Number(p?.amount ?? 0), 0);
  const paidSoFar =
    paidFromPartials || Number(invoiceDetails?.amount ?? 0);
  const remaining = Math.max(totalBill - paidSoFar, 0);
  const splitMeta = invoiceable?.meta?.partial_type
    ? invoiceable.meta
    : partials[0]?.meta || null;
  const isRatioSplit = splitMeta?.partial_type === "ratio";
  const splitPerson = Number(splitMeta?.data?.person ?? 0);
  const splitPayer = Number(splitMeta?.data?.payer ?? 0);
  const currencyCode =
    invoiceDetails?.business?.currency ||
    appState?.storeInfo?.currencyCode ||
    "KWD";
  const money = (value) =>
    formatMoney(value, currencyCode, appState?.langValue);

  const statusLabel = (status) => {
    if (status === "Paid") return t("OrderStatus.Paid");
    if (status === "Pending") return t("OrderStatus.Pending");
    if (status === "Failed") return t("OrderStatus.Failed");
    if (status === "Cancelled") return t("OrderStatus.Cancelled");
    return status || "-";
  };

  return (
    <div className={`partial-payment-summary ${className}`.trim()}>
      <div className="partial-payment-summary__title">
        {t("OrderStatus.Split-payment")}
      </div>

      {isRatioSplit && splitPerson > 0 ? (
        <div className="partial-payment-summary__ratio">
          {t("OrderStatus.Split-among", {
            person: splitPerson,
            payer: splitPayer || 1,
          })}
        </div>
      ) : null}

      <div className="partial-payment-summary__rows">
        {partials.map((partial) => (
          <div
            key={partial.id || `${partial.amount}-${partial.status}`}
            className="partial-payment-summary__row"
          >
            <span className="partial-payment-summary__label">
              #{partial.id}
              <span
                className={`partial-payment-summary__status partial-payment-summary__status--${String(
                  partial.status || ""
                ).toLowerCase()}`}
              >
                {statusLabel(partial.status)}
              </span>
            </span>
            <strong>{money(partial.amount)}</strong>
          </div>
        ))}

        <div className="partial-payment-summary__row">
          <span>{t("OrderStatus.Paid-so-far")}</span>
          <strong>{money(paidSoFar)}</strong>
        </div>
        <div className="partial-payment-summary__row">
          <span>{t("OrderStatus.Remaining")}</span>
          <strong>{money(remaining)}</strong>
        </div>
      </div>
    </div>
  );
}

export default PartialPaymentSummary;
